"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyListPlaceholder = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18next = require("react-i18next");

var View = function View(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClick,
    disabled: disabled,
    className: (0, _classnames["default"])('px-6 py-2 truncate w-full text-left', {
      'font-bold hover:bg-secondary': !disabled,
      'text-gray-light cursor-default': disabled
    })
  }, children);
};

View.displayName = 'Email';
var _default = View;
exports["default"] = _default;

var EmptyListPlaceholder = function EmptyListPlaceholder(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm select-none"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.filter.action.forward.emptyList"
  }, "No available address to forward.", /*#__PURE__*/_react["default"].createElement("span", {
    onClick: onClick,
    className: "text-primary cursor-pointer"
  }, "Add forwarding address")));
};

exports.EmptyListPlaceholder = EmptyListPlaceholder;
//# sourceMappingURL=Email.js.map